import { Injectable, signal } from '@angular/core';

/**
 * Prevents duplicate "server down" notifications when multiple concurrent
 * requests fail simultaneously with a status 0 (no connection).
 *
 * The first failure triggers the notification; subsequent failures within
 * the suppression window are silently discarded.
 */
@Injectable({ providedIn: 'root' })
export class ConnectionErrorService {
  private readonly active = signal(false);
  private resetTimer: ReturnType<typeof setTimeout> | null = null;

  /**
   * Calls `showFn` only if no connection-error notification is currently
   * active. Resets the gate after `suppressDurationMs` milliseconds so
   * a new outage will surface again if it occurs later.
   */
  notifyOnce(showFn: () => void, suppressDurationMs = 5000): void {
    if (this.active()) return;

    this.active.set(true);
    showFn();

    if (this.resetTimer) clearTimeout(this.resetTimer);
    this.resetTimer = setTimeout(() => {
      this.active.set(false);
      this.resetTimer = null;
    }, suppressDurationMs);
  }
}
